<template>
    <component :is="currentLayoutComponent">
        <slot />
    </component>
</template>

<script setup>
import { computed, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import LayoutVerticalMenu from './LayoutVerticalMenu.vue';
import LayoutHorizontalMenu from './LayoutHorizontalMenu.vue';
import { getSessionValue } from '@helper/utils.js';

const page = usePage();

// Reaktywnie pobierz orientację menu z różnych źródeł
const menuOrientation = computed(() => {
    // Najpierw sprawdź Inertia props (najbardziej aktualne)
    if (page.props.menuOrientation) {
        //console.log('Menu orientation from Inertia props:', page.props.menuOrientation);
        return page.props.menuOrientation;
    }

    // Następnie sprawdź sessionStorage
    try {
        const orientation = getSessionValue('user.menuOrientation');
        if (orientation) {
            //console.log('Menu orientation from session:', orientation);
            return orientation;
        }
    } catch (e) {
        console.warn('Error reading menu orientation from session:', e);
    }

    // Domyślnie poziome
    //console.log('Using default menu orientation: H');
    return 'H';
});

// Reaktywnie wybierz komponent layout
const currentLayoutComponent = computed(() => {
    const orientation = menuOrientation.value;
    const component = orientation === 'V' ? LayoutVerticalMenu : LayoutHorizontalMenu;
    //console.log('Current layout component:', orientation === 'V' ? 'VerticalMenu' : 'HorizontalMenu');
    return component;
});

// Nasłuchuj zmian orientacji i loguj je
watch(menuOrientation, (newOrientation, oldOrientation) => {
    if (newOrientation !== oldOrientation) {
        // console.log(`Menu orientation changed from ${oldOrientation} to ${newOrientation}`);
    }
}, { immediate: true });
</script>
